import { PlanMarket } from '@zorro/clients';
import { Pill } from '@zorro/design-system/v2/Pill';
import { Box, Badge as OldBadge } from '@zorro/web/design-system';
import { screamingSnakeCaseToText } from '@zorro/web/ui-utils';

import { PlanMarketConfig, PlanMarketIcon } from './PlanMarketEnrollmentUtils';

type PlanMarketBadgeProps = {
  planMarket: PlanMarket;
};

export const PlanMarketBadgeTableView = ({
  planMarket,
}: PlanMarketBadgeProps) => {
  return (
    <Box w="min-content" ml="xs">
      <Pill
        variant="with-icon"
        color={PlanMarketConfig[planMarket].color}
        leftSection={<PlanMarketIcon planMarket={planMarket} />}
      >
        {screamingSnakeCaseToText(planMarket)}
      </Pill>
    </Box>
  );
};

export const PlanMarketBadgePageView = ({
  planMarket,
}: PlanMarketBadgeProps) => {
  return (
    <OldBadge
      size="md"
      variant="transparent"
      c={PlanMarketConfig[planMarket].badgeColor}
      bg={PlanMarketConfig[planMarket].badgeBg}
      radius={4}
      p="4px 8px"
      h={24}
      style={{ fontSize: '14px' }}
    >
      {screamingSnakeCaseToText(planMarket)}
    </OldBadge>
  );
};
